import { render, staticRenderFns } from "./lottery-conf.vue?vue&type=template&id=c74ca944&scoped=true&"
import script from "./lottery-conf.vue?vue&type=script&lang=js&"
export * from "./lottery-conf.vue?vue&type=script&lang=js&"
import style0 from "./lottery-conf.vue?vue&type=style&index=0&id=c74ca944&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74ca944",
  null
  
)

export default component.exports